/*-----------------------------------------------------------------
- Message translations
-----------------------------------------------------------------*/
export default {

    complete  : 'کامل شده',
    loading   : 'در حال انجام',
    pending   : 'در انتظار',
    of_step   : '{0} از {1}',
    on_loading: 'درحال بارگذاری ...',
    empty     : 'این بخش خالی‌ست.',

    error: {
        upload: {
            common: 'مشکلی در آپلود به وجود آمده است.',
        },
    },

    success: {
        upload: {
            common: 'فایل شما با موفقیت بارگذاری شد.',
        },
    },

    cloner: {
        confirm_delete    : 'آیا از حذف این آیتم مطمئنید؟',
        confirm_delete_all: 'آیا از حذف تمام آیتم‌ها مطمئنید؟',
    },

    login_first: 'لطفا ابتدا وارد شوید.',

};
